import { AsAccessToken } from "@infobis/api-module";

class LocalStorageService{

  setAccessToken = (user: AsAccessToken): void=>{
    const userCopy = JSON.stringify(user)
    localStorage.setItem('lastLogin', userCopy)
  }
  
  delToken = (): void =>{
    localStorage.removeItem('lastLogin');
  }

  getToken = (): AsAccessToken =>{
    const tokenCopy = localStorage.getItem('lastLogin')
      return tokenCopy ? JSON.parse(tokenCopy) : {}
  }

  tokenExists = (): boolean =>{
    const tokenExists = localStorage.getItem('lastLogin')
    return !!tokenExists
  }

  // setCompany = (company: IKeepingShortCompany): void =>{
  //   const companyCopy = JSON.stringify(company)
  //   localStorage.setItem('company', companyCopy)
  // }
  //
  // getCompany = (): IKeepingShortCompany =>{
  //   const companyCopy = localStorage.getItem('company')
  //   return companyCopy ? JSON.parse(companyCopy) : {}
  // }

  delCompany = (): void =>{
    localStorage.removeItem('company')
  }
  
  getServerId = () =>{
    let serverId = localStorage.getItem('lastLogin')
    return serverId ? JSON.parse(serverId).serverId : ''
  }
  
  getCompanyId = () =>{
    let companyId = localStorage.getItem('company')
    return companyId ? JSON.parse(companyId).companyId : ''
  }
  
  getDepartment = () =>{
    let departmentId = localStorage.getItem('company')
    return departmentId ? JSON.parse(departmentId!).departmentId : ''
  }
  
  setFieldsTypeFilters = (listFilters: any) =>{
    const filtersTypeField = JSON.stringify(listFilters)
    localStorage.setItem('filtersTypeField', filtersTypeField)
  }
  getFieldsTypeFilters = () =>{
    let filtersTypeFields = localStorage.getItem('filtersTypeFields')
    return filtersTypeFields ?  JSON.parse(filtersTypeFields!) : ''
  }
  
  setUnitsStatusFilters = (listFilters: any) =>{
    const filtersStatusUnits = JSON.stringify(listFilters)
    localStorage.setItem('filtersStatusUnits', filtersStatusUnits)
  }
  getUnitsStatusFilters = () =>{
    let filtersStatusUnits = localStorage.getItem('filtersStatusUnits')
    return filtersStatusUnits ?  JSON.parse(filtersStatusUnits!) : ''
  }
  
  setUnitsTypeFilters = (listFilters: any) =>{
    const filtersTypeUnits = JSON.stringify(listFilters)
    localStorage.setItem('filtersTypeUnits', filtersTypeUnits)
  }
  getUnitsTypeFilters = () =>{
    let filtersTypeUnits = localStorage.getItem('filtersTypeUnits')
    return filtersTypeUnits ?  JSON.parse(filtersTypeUnits!) : ''
  }
  
}

export default new LocalStorageService()